import { Link, useParams } from "react-router-dom";

// Faz 2 stub. Only unbuilt product routes (/basvuru/:urun for a line without its own flow,
// e.g. konut) resolve here; the five live products + the advisor CTAs reach real flows.
const URUN_ADI: Record<string, string> = {
  trafik: "Trafik Sigortası",
  kasko: "Kasko",
  saglik: "Sağlık Sigortası",
  dask: "DASK",
  seyahat: "Seyahat Sigortası",
};

export function Placeholder() {
  const { urun } = useParams();
  const ad = urun ? (URUN_ADI[urun] ?? urun) : "Danışman eşleşmesi";
  return (
    <main
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "14px",
        padding: "40px",
        textAlign: "center",
        fontFamily: '"Hanken Grotesk", system-ui, sans-serif',
        color: "#16294C",
      }}
    >
      <div
        style={{
          fontSize: "12px",
          fontWeight: 700,
          letterSpacing: "0.06em",
          textTransform: "uppercase",
          color: "#1F9D5F",
        }}
      >
        Yakında · Faz 2
      </div>
      <h1 style={{ fontSize: "32px", fontWeight: 700, letterSpacing: "-0.02em", margin: 0 }}>
        {ad}
      </h1>
      <p style={{ fontSize: "16px", color: "#5A6876", maxWidth: "420px", margin: 0 }}>
        Teklif talebi akışı hazırlanıyor. Danışmanınız kısa süre içinde sizin için üç teklif
        hazırlayacak.
      </p>
      <Link
        to="/"
        style={{
          marginTop: "8px",
          display: "inline-flex",
          alignItems: "center",
          gap: "7px",
          background: "#00249E",
          color: "#fff",
          borderRadius: "11px",
          padding: "12px 22px",
          fontSize: "14px",
          fontWeight: 600,
        }}
      >
        Ana sayfaya dön
      </Link>
    </main>
  );
}
